(() => {
  'use strict';
  if (window.rudcaShippingProgressReady) return;
  window.rudcaShippingProgressReady = true;
  const selector = '[data-rudca-shipping-progress]';
  const storageKey = 'rudca:shipping-threshold-seen:v1';
  let seen = new Set();
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) seen = new Set(saved.filter(value => typeof value === 'string'));
  } catch (_) {}
  let baseline = null;
  let currentEpoch = -1;
  let settledEpoch = -1;
  let waiting = false;
  let suspended = false;
  let feedbackTimer = null;

  function persist() {
    try { window.sessionStorage.setItem(storageKey, JSON.stringify([...seen])); } catch (_) {}
  }
  function surface() {
    return document.querySelector('[data-section-type="cart"]') || document.querySelector('.mini-cart');
  }
  function snapshot() {
    const host = surface();
    if (!host) return null;
    const node = host.querySelector(selector);
    if (!node) return host.getAttribute('data-item-count') === '0' ? {count: 0, amount: 0, reached: false} : null;
    const amount = Number(node.dataset.subtotal);
    const threshold = Number(node.dataset.threshold);
    const count = Number(node.dataset.count);
    const currency = node.dataset.currency;
    if (![amount, threshold, count].every(Number.isSafeInteger) || amount < 0 || threshold <= 0 || count <= 0 || !/^[A-Z]{3}$/.test(currency || '')) return null;
    return {node, amount, threshold, count, currency, scope: `${currency}:${threshold}`, reached: amount >= threshold};
  }
  function remember(state) {
    if (state && state.count === 0) { seen.clear(); persist(); }
    else if (state && state.reached) { seen.add(state.scope); persist(); }
    baseline = state;
  }
  function clearFeedback() {
    window.clearTimeout(feedbackTimer);
    feedbackTimer = null;
    document.querySelectorAll(selector).forEach(node => {
      node.classList.remove('is-celebrating');
      const label = node.querySelector('[data-rudca-shipping-message]');
      if (label && label.hasAttribute('data-rudca-shipping-resting')) {
        label.textContent = label.getAttribute('data-rudca-shipping-resting');
        label.removeAttribute('data-rudca-shipping-resting');
      }
      const status = node.querySelector('[data-rudca-shipping-announcement]');
      if (status && status.textContent) status.textContent = '';
    });
  }
  function pending() {
    return waiting || document.documentElement.hasAttribute('data-rudca-cart-pending');
  }
  function renderPending() {
    const busy = pending();
    if (busy) clearFeedback();
    document.querySelectorAll(selector).forEach(node => {
      if (busy) node.setAttribute('aria-busy', 'true');
      else node.removeAttribute('aria-busy');
      const content = node.querySelector('[data-rudca-shipping-content]');
      const updating = node.querySelector('[data-rudca-shipping-updating]');
      const projected = node.getAttribute('data-rudca-cart-projected');
      const unknown = projected === 'pending' || busy && projected !== 'amount';
      node.setAttribute('data-rudca-shipping-pending', unknown ? 'true' : 'false');
      if (content) {
        content.hidden = false;
        if (unknown) content.setAttribute('aria-hidden', 'true');
        else content.removeAttribute('aria-hidden');
      }
      if (updating) updating.hidden = !unknown;
    });
  }
  function begin(event) {
    const epoch = event.detail && event.detail.epoch;
    if (suspended || !Number.isSafeInteger(epoch) || epoch <= currentEpoch) return;
    currentEpoch = epoch;
    waiting = true;
    clearFeedback();
    renderPending();
  }
  function matches(state, cart) {
    if (!state || !cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || !Number.isSafeInteger(cart.total_price)) return false;
    if (state.count === 0) return cart.item_count === 0 && cart.total_price === 0 && cart.items.length === 0;
    return state.count === cart.item_count && state.amount === cart.total_price && state.currency === cart.currency && cart.requires_shipping === true;
  }
  function settle(event) {
    const detail = event.detail || {};
    const epoch = detail.epoch;
    if (suspended || !Number.isSafeInteger(epoch) || epoch < currentEpoch || epoch <= settledEpoch) return;
    if (document.documentElement.hasAttribute('data-rudca-cart-pending')) return;
    currentEpoch = epoch;
    settledEpoch = epoch;
    waiting = false;
    clearFeedback();
    renderPending();
    const next = snapshot();
    if (!matches(next, detail.cart)) { baseline = null; return; }
    const crossed = baseline && (baseline.count === 0 || baseline.scope === next.scope && !baseline.reached) && next.reached;
    const celebrate = detail.successfulMutation === true && crossed && !seen.has(next.scope);
    remember(next);
    if (!celebrate || !next.node || document.visibilityState === 'hidden') return;
    next.node.classList.add('is-celebrating');
    const label = next.node.querySelector('[data-rudca-shipping-message]');
    if (label && next.node.dataset.celebration) {
      label.setAttribute('data-rudca-shipping-resting', label.textContent);
      label.textContent = next.node.dataset.celebration;
    }
    const status = next.node.querySelector('[data-rudca-shipping-announcement]');
    if (status) status.textContent = next.node.dataset.celebration || '';
    feedbackTimer = window.setTimeout(clearFeedback, 1800);
  }
  function rerender() {
    clearFeedback();
    renderPending();
    if (!pending() && !suspended) remember(snapshot());
  }
  function initialize() {
    remember(snapshot());
    renderPending();
    const observer = new MutationObserver(renderPending);
    observer.observe(document.documentElement, {attributes: true, attributeFilter: ['data-rudca-cart-pending']});
  }
  document.addEventListener('rudca:cart-started', begin);
  document.addEventListener('rudca:cart-settled', settle);
  document.addEventListener('cart:rerendered', rerender, true);
  document.addEventListener('shopify:section:load', rerender);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') clearFeedback(); });
  window.addEventListener('pagehide', () => { suspended = true; waiting = false; baseline = null; clearFeedback(); });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    suspended = false;
    waiting = false;
    remember(snapshot());
    renderPending();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
